/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Customer_Debt_Dup_Receipt_TitleInputs */

const vi_customer_debt_dup_receipt_title = /** @type {(inputs: Customer_Debt_Dup_Receipt_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phiếu thu có thể bị trùng`)
};

/**

* @param {Customer_Debt_Dup_Receipt_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const customer_debt_dup_receipt_title = /** @type {((inputs?: Customer_Debt_Dup_Receipt_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Customer_Debt_Dup_Receipt_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_customer_debt_dup_receipt_title(inputs)
});